<template>
  <div>
    <b-modal
      id="modal_itens"
      title="Adicionar Produto"
      ref="my-modal"
      size="lg"
      hide-footer
      modal-class="modal-add-product"
      @show="resetModal"
      @hidden="resetModal"
      scrollable
    >
      <!-- Client Info Bar -->
      <div v-if="getFormData && getFormData.cliente" class="client-info-bar">
        <div class="client-info">
          <feather-icon icon="UserIcon" size="16" />
          <div class="info-content">
            <span class="label">CLIENTE</span>
            <span class="value">{{ getFormData.cliente.clientenomeabreviado || 'Cliente' }}</span>
          </div>
        </div>

        <div class="order-info">
          <!-- Chip TABELA removido a pedido do cliente -->
          <div class="info-item">
            <feather-icon icon="ShoppingCartIcon" size="16" />
            <div class="info-content">
               <span class="label">ITENS</span>
               <span class="value">{{ totalItensNoPedido }}</span>
            </div>
          </div>
        </div>
      </div>

      <!--
        Seletor de tipo de busca + Busca por Marca e Categoria — DESATIVADOS.
        Fluxo de novo pedido simplificado: apenas a busca por ISBN/SKU ou nome
        do produto (código de referência) fica disponível. Mantido comentado
        para reativação futura (basta descomentar e remover/ajustar o data()
        `tipoBusca` e o resetModal).

      <b-row class="mb-1 mt-1">
        <b-col md="12">
          <b-form-group label="Tipo de Busca:">
            <b-form-radio-group
              v-model="tipoBusca"
              :options="opcoesTypeBusca"
              @change="onTipoBuscaChange"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row v-if="tipoBusca === 'marca-categoria'" class="gx-3 gy-2 align-items-center justify-content-center">
        <b-col md="3">
          <b-form-group label="Marca">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <b-spinner small variant="success" v-show="getIsLoadingMarca" />
                <feather-icon
                  icon="TagIcon"
                  size="18"
                  :color="$store.state.intensPedido.setExisteMarca ? '#1f9d57' : '#dc2626'"
                  v-if="!getIsLoadingMarca"
                />
              </b-input-group-prepend>
              <b-form-select
                v-model="selected_cod_marca"
                :options="getEsMarcas"
                :state="$store.state.intensPedido.setExisteMarca"
                @change="limparCamposDependendes"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group label="Categoria">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <b-spinner small variant="success" v-show="getIsLoadingCategoria" />
                <feather-icon
                  icon="ShoppingBagIcon"
                  size="18"
                  :color="$store.state.intensPedido.setExisteCategoria ? '#1f9d57' : '#dc2626'"
                  v-if="!getIsLoadingCategoria"
                />
              </b-input-group-prepend>
              <b-form-select
                v-model="selected_categoria"
                :options="getEsCategorias"
                :disabled="!selected_cod_marca || getIsLoadingCategoria || getIsLoadingReferencia || isLoadingAllData"
                :state="$store.state.intensPedido.setExisteCategoria"
                @change="limparReferencia"
              />
              <b-form-invalid-feedback
                v-show="!getIsLoadingCategoria && !$store.state.intensPedido.setExisteCategoria && selected_cod_marca"
                tooltip
              >
                A marca selecionada não possui categorias cadastradas.
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col md="2">
          <b-form-group label=" ">
            <b-button
              variant="primary"
              block
              class="mt-1"
              :disabled="!selected_cod_marca || !selected_categoria || isLoadingAllData"
              @click="buscarReferencias"
            >
              <feather-icon icon="SearchIcon" size="18" class="mr-1" />
              Buscar
            </b-button>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label=" ">
            <b-button
              variant="danger"
              block
              class="mt-1"
              @click="limparFiltros"
            >
              <feather-icon icon="TrashIcon" size="18" class="mr-1" />
              Limpar
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>
      -->

      <!-- Busca simples: texto + filtros de atributo -->
      <div class="filtros-busca mt-1">
        <b-row class="gx-2">
          <b-col cols="12">
            <b-form-group label="Buscar por ISBN, SKU ou nome do produto">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <b-spinner small variant="success" v-show="getIsLoadingReferencia" />
                  <feather-icon icon="SearchIcon" size="18" v-if="!getIsLoadingReferencia" />
                </b-input-group-prepend>
                <b-form-input
                  v-model="filtroTexto"
                  placeholder="Digite o ISBN, SKU ou nome do produto (opcional)"
                  :disabled="isLoadingAllData"
                  @keyup.enter="buscarPorFiltros"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="gx-2 align-items-end">
          <b-col cols="12" sm="6" md="2" v-if="filtrosOptions.lingua.length">
            <b-form-group label="Língua" class="filtro-atributo-group">
              <b-form-select v-model="filtroLingua" :disabled="isLoadingAllData"
                :options="[{ value: null, text: 'Todas' }, ...filtrosOptions.lingua]" />
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="2" v-if="filtrosOptions.segmento.length">
            <b-form-group label="Segmento" class="filtro-atributo-group">
              <b-form-select v-model="filtroSegmento" :disabled="isLoadingAllData"
                :options="[{ value: null, text: 'Todos' }, ...filtrosOptions.segmento]" />
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="2" v-if="filtrosOptions.marcas.length > 1">
            <b-form-group label="Marca" class="filtro-atributo-group">
              <b-form-select v-model="filtroMarca" :disabled="isLoadingAllData"
                :options="[{ value: null, text: 'Todas' }, ...filtrosOptions.marcas.map((m) => ({ value: m.cod_marca, text: m.des_marca }))]" />
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="2" v-if="filtrosOptions.niveleducacional.length">
            <b-form-group label="Nível educacional" class="filtro-atributo-group">
              <b-form-select v-model="filtroNivel" :disabled="isLoadingAllData"
                :options="[{ value: null, text: 'Todos' }, ...filtrosOptions.niveleducacional]" />
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="2" v-if="filtrosOptions.colecao.length">
            <b-form-group label="Coleção" class="filtro-atributo-group">
              <b-form-select v-model="filtroColecao" :disabled="isLoadingAllData"
                :options="[{ value: null, text: 'Todas' }, ...filtrosOptions.colecao]" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="2" class="d-flex align-items-end">
            <b-form-group label=" " class="w-100 mb-1">
              <div class="d-flex" style="gap: 6px;">
                <b-button
                  variant="primary"
                  class="flex-grow-1"
                  :disabled="isLoadingAllData"
                  @click="buscarPorFiltros"
                >
                  <feather-icon icon="SearchIcon" size="16" class="mr-25" />
                  Buscar
                </b-button>
                <b-button
                  variant="outline-danger"
                  :disabled="isLoadingAllData"
                  @click="limparFiltrosAtributo"
                >
                  <feather-icon icon="TrashIcon" size="16" />
                </b-button>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </div>

      <!-- Totais -->
      <b-row class="justify-content-end mt-3">
        <b-col cols="auto" class="text-right">
          <p><strong>Total de Pedidos:</strong> {{ totalUnidades }}</p>
          <p>
            <strong>Custo Total:</strong>
            {{ dinheiroVisual(totalVisualItens) }}
          </p>
        </b-col>
      </b-row>

      <!-- Loading -->
      <div v-if="isLoadingAllData" class="loading-indicator text-center my-2">
        <b-spinner small type="grow" class="mr-2"></b-spinner>
        Carregando mais itens...
      </div>

      <!-- Inserção de Itens -->
      <inserir-item-modal
        :cotacoes-preco-visuais="cotacoesVisuais"
        :tipo-pedido-preco-visual="tipoPedidoVisual"
        :before-add-item="prepararItemParaAdicionar"
        :manages-client-category="true"
        @update:grade-item="updatedGradeItens"
        @calcular-imposto="calcularImposto"
        @remove-item="handleRemoveItem"
        @select-item="carregarDetalheReferencia"
      />

      <!-- Carregar mais itens (lazy/paginado + scroll infinito) -->
      <div v-if="temMaisReferencias" class="text-center my-2">
        <!-- Sentinela do IntersectionObserver: dispara o próximo bloco ao chegar perto do fim -->
        <div ref="sentinelaCarregarMais" class="sentinela-carregar-mais"></div>
        <!-- Indicador discreto no fim da lista durante o auto-load por scroll -->
        <div v-if="isLoadingAllData" class="loading-indicator text-center my-2">
          <b-spinner small type="grow" class="mr-2"></b-spinner>
          Carregando mais itens...
        </div>
        <b-button v-else variant="outline-primary" @click="carregarMaisReferencias">
          <feather-icon icon="ChevronDownIcon" size="16" class="mr-50" />
          Carregar mais itens ({{ referenciasPendentes.length }} restantes)
        </b-button>
      </div>

      <div class="modal-actions-footer">
        <div class="items-summary" v-if="itensTabela.length > 0">
          <span class="summary-count">{{ itensTabela.length }} item(s)</span>
          <!-- Lista compacta dos nomes adicionados: até 3 + "e mais X",
               com tooltip contendo a lista completa. -->
          <span class="summary-nomes" :title="resumoItensTitulo">{{ resumoItensNomes }}</span>
          <span class="summary-separator">|</span>
          <span class="summary-total">{{ dinheiroVisual(totalVisualItens) }}</span>
        </div>
        <div class="actions-buttons" :class="{ 'ml-auto': itensTabela.length === 0 }">
           <b-button variant="outline-secondary" @click="$refs['my-modal'].hide()">
             <feather-icon icon="XIcon" size="16" class="mr-50" />
             Cancelar
           </b-button>
           <b-button variant="success" @click="handleOk" :disabled="!podeAdicionarItens">
             <feather-icon icon="CheckIcon" size="16" class="mr-50" />
             Salvar
           </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BFormSelect, BFormInput, BCol, BButton, BInputGroup, BInputGroupPrepend,
} from 'bootstrap-vue';
import ProductionItem from '@/views/app/operacoes/pedidosVendas/swipper/swipperItensProdutos.vue';
import GradePedidos from '@/views/app/operacoes/pedidosVendas/tabelaGrade/gradePedidos.vue';
import apiAxios from '@/libs/axios';
import ECommerceProductDetails from '@/views/app/CartECommerce/e-commerce-product-details/ECommerceProductDetails.vue';
import InserirItemModal from '@/views/app/operacoes/pedidosVendas/inserirItemModal.vue';
import Swal from 'sweetalert2';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import { simularImpostoUnitario, aplicarPrecoDoacao, isPedidoDoacao } from '@/utils/impostoSimulador';
import { selecionarNaturezaFiscal } from '@/utils/naturezaFiscal';
import { precoFinalSimulado, precoTabelaSimulado } from '@/utils/precoProveniencia';
import SLSEstoqueService from '@/services/SistemaDKP/SLSEstoque.service';
import adicionarProdutoModalMixin from './adicionarProdutoModal.mixin';
import categoriaPedidoClienteMixin, { categoriaDaLinha } from './categoriaPedidoCliente.mixin';

export default {
  components: {
    InserirItemModal,
    ECommerceProductDetails,
    GradePedidos,
    BButton,
    BFormInput,
    BModal,
    BCol,
    BFormSelect,
    ProductionItem,
    BInputGroup,
    BInputGroupPrepend,
  },
  mixins: [adicionarProdutoModalMixin, categoriaPedidoClienteMixin],
  mounted() {
    this.$root.$on('pic:items-added', this.onPicItemsAdded);
  },
  beforeDestroy() {
    this.$root.$off('pic:items-added', this.onPicItemsAdded);
  },
  data() {
    return {
      // Novo pedido simplificado: busca somente por ISBN/SKU ou nome do produto.
      // A busca por Marca e Categoria foi desativada (comentada no template).
      // Sobrescreve o default do mixin (que é 'marca-categoria').
      tipoBusca: 'codigo-referencia',
      calculationGeneration: 0,
      modalEpoch: 0,
      calculationPending: false,
      selectionCalculationReady: false,
    };
  },
  computed: {
    podeAdicionarItens() {
      const linhasCalculadas = this.itensTabela
        .filter((item) => item._requiresCurrentCalculation);
      return this.novosItensAdicionados
        && this.selectionCalculationReady
        && !this.calculationPending
        && linhasCalculadas.length > 0
        && linhasCalculadas.every((item) => (
          item._calculationReady === true
          && Number.isFinite(Number(item.precoComImposto))
          && Number(item.precoComImposto) > 0
          && item._calculationContext === this._contextoCalculo(item)
        ));
    },
    // Nomes dos itens adicionados (usa descrição/nome disponível na linha).
    resumoItensListaNomes() {
      return (this.itensTabela || []).map((it) => (
        it.descricao_referencia || it.nome || it.item_descricao || it.itemId || 'Item'
      ));
    },
    // Exibe até 3 nomes + "e mais X" para não quebrar o layout.
    resumoItensNomes() {
      const nomes = this.resumoItensListaNomes;
      if (!nomes.length) return '';
      const visiveis = nomes.slice(0, 3);
      const restante = nomes.length - visiveis.length;
      return restante > 0 ? `${visiveis.join(', ')} e mais ${restante}` : visiveis.join(', ');
    },
    // Tooltip com a lista completa.
    resumoItensTitulo() {
      return this.resumoItensListaNomes.join('\n');
    },
  },
  methods: {
    onPicItemsAdded(event) {
      if (event.type !== 'operacao-pedido'
        || this.$store.getters['preferencias/picAtivo'] !== true) return;
      // The promotional groups are already in the order store.
      // Preserve any unsaved normal selection instead of closing over it.
      if (!this.novosItensAdicionados) this.$refs['my-modal'].hide();
    },
    getTabelaPrecoId() {
      return this.getFormData.dataCapaPedido.tabelaprecoid;
    },
    async carregarDetalheReferencia(product) {
      if (!product || product._detalheCarregado || product._carregandoDetalhe) return;
      const modalEpoch = this.modalEpoch;
      const selectedSku = product.item_id ?? product.itemId ?? product.CodItem;
      this.atualizarItemJsonTelaNovaPedido({ referencia: product.referencia, itemId: selectedSku, patch: { _carregandoDetalhe: true } });
      try {
        const apiCache = {};

        // Simulação de imposto SEMPRE via backend (POST /api/imposto/simular):
        // o backend resolve item_id -> item_codigo_origem (ISBN/EAN) antes de
        // chamar a TOTVS. Chamar a TOTVS direto do navegador com o item_id
        // interno (ex.: "74") retorna vazio (livros sem grade não têm SKU
        // mapeado), e em produção o host da TOTVS é inalcançável pelo browser.
        const simularImpostoWithCache = async (itemId, precoUnitarioBase) => {
          const formData = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] || {};
          const cacheKey = `imposto:${itemId}:${precoUnitarioBase}`;
          if (apiCache[cacheKey] !== undefined) return apiCache[cacheKey];

          const calculo = await simularImpostoUnitario({
            formData: {
              ...formData,
              enderecoAlternativo: this.$store.getters['InfoPedido/GET_ENDERECO_ALTERNATIVO'],
            },
            itemId,
            precoBase: precoUnitarioBase,
            comProveniencia: true,
          });
          this.registrarCotacaoVisual(itemId, calculo);
          apiCache[cacheKey] = calculo;
          return calculo;
        };

        const refCode = product.referencia ?? 0;
        const detalhes = await this.getDetalhesItem(
          refCode, product.cod_marca, product.cod_categ, selectedSku,
        );

        if (!detalhes || !detalhes.Result) {
          this.atualizarItemJsonTelaNovaPedido({ referencia: product.referencia, itemId: selectedSku, patch: { _detalheCarregado: true } });
          return;
        }

        const itemData = detalhes.Result?.data?.Result
          || detalhes.Result?.data
          || detalhes.Result?.Result
          || detalhes.Result
          || detalhes.data?.Result
          || detalhes.data;
        const exactItem = itemData?.item || {};

        // Ignorar respostas "vazias" vindas do getDetalhesItem
        // Exemplo: { Marca: [...], imagens: null, Embalagens: null, corTamanho: null, tabelaPreco: null, familiaComercial: null }
        const allNullBlocks = (
          !itemData?.imagens
          && !itemData?.Embalagens
          && !itemData?.corTamanho
          && !itemData?.tabelaPreco
          && !itemData?.familiaComercial
        );

        // Family metadata is optional for an exact SKU.  Only reject a truly
        // empty response; never use a missing family as a reason to discard a
        // sellable item row.
        if (allNullBlocks || !itemData) {
          console.warn(`Referência ${refCode} sem dados detalhados úteis.`);
          this.atualizarItemJsonTelaNovaPedido({ referencia: product.referencia, itemId: selectedSku, patch: { _detalheCarregado: true } });
          return;
        }

        const corTamanhoArr = Array.isArray(itemData.corTamanho) ? itemData.corTamanho : [];
        const gradeBuilt = (() => {
          const ttHBIgrade = corTamanhoArr.map((row) => ({
            cdnCor: row.cdn_cor,
            desCor: row.des_cor,
            itemExtrapq: row.pp?.item_id || null,
            itemPequeno: row.p?.item_id || null,
            itemMedio: row.m?.item_id || null,
            itemGrande: row.g?.item_id || null,
            itemExtraGd: row.gg?.item_id || null,
            itemSuperGd: row.xg?.item_id || null,
            itemUltraGd: row.xgg?.item_id || null,
            itemUnico: row.unico?.item_id || null,
            itemOutros: row.diversos?.item_id || null,
          })).filter((r) => r.cdnCor || r.desCor);
          return ttHBIgrade.length > 0 ? { dsHBIgrade: { ttHBIgrade } } : null;
        })();

        const embalagensArray = Array.isArray(itemData.Embalagens) ? itemData.Embalagens : [];
        const embalagensProcessadas = embalagensArray.map((embalagem) => ({
          descricao_embalagem: embalagem.des_embalag,
          cdn_embalagem: embalagem.cdn_embalagem,
          grade: gradeBuilt,
          itemMultiplo: 0,
        }));

        // Keep the exact row SKU selected by the catalog.  The first grade
        // child is a sibling SKU and must never replace it.
        const firstSkuId = selectedSku;
        const selectedSizeKeys = ['pp', 'p', 'm', 'g', 'gg', 'xg', 'xgg', 'unico', 'diversos'];
        const selectedGrade = corTamanhoArr.find((row) => selectedSizeKeys.some(
          (key) => String(row?.[key]?.item_id ?? '') === String(selectedSku ?? ''),
        ));
        const selectedSizeKey = selectedGrade
          ? selectedSizeKeys.find((key) => String(selectedGrade?.[key]?.item_id ?? '') === String(selectedSku ?? ''))
          : null;
        // Preço base pode não existir (ex.: tabelaPreco = null). Proteger acessos ao índice [0].
        const precoBase = Number(itemData.tabelaPreco?.[0]?.tabelapreco_item_preco
          ?? itemData.tabelaPreco?.[0]?.preco
          ?? exactItem.preco ?? product.item_price_base ?? product.item_price ?? 0);
        const calculo = firstSkuId ? await simularImpostoWithCache(firstSkuId, precoBase) : null;
        const precoComImposto = calculo?.preco ?? null;

        const imagemPrincipal = Array.isArray(itemData.imagens)
          ? itemData.imagens.find((img) => img.imagemPrincipal === 1)
          : null;
        const caminhoImagemPrincipal = imagemPrincipal ? imagemPrincipal.caminho : null;

        const fallbackPreco = Number(itemData.tabelaPreco?.[0]?.tabelapreco_item_preco
          ?? itemData.tabelaPreco?.[0]?.preco
          ?? exactItem.preco ?? product.item_price_base ?? product.item_price ?? 0);
        if (modalEpoch !== this.modalEpoch) return;
        const precoCalculado = Number(precoComImposto);
        const unitPrice = precoComImposto !== null && Number.isFinite(precoCalculado)
          ? precoCalculado
          : null;
        const familiaItemId = itemData.familiaComercial?.[0]?.item_id ?? '';
        const selectedDescricao = product.item_descricao ?? product.itemDescricao
          ?? product.Descricao ?? exactItem.item_descricao ?? exactItem.itemDescricao
          ?? itemData.item_descricao ?? itemData.itemDescricao
          ?? itemData.familiaComercial?.[0]?.Referencia ?? product.item_name;

        this.atualizarItemJsonTelaNovaPedido({
          referencia: product.referencia,
          itemId: selectedSku,
          patch: {
            item_name: selectedDescricao,
            item_descricao: selectedDescricao,
            itemDescricao: selectedDescricao,
            Descricao: itemData.Descricao ?? selectedDescricao,
            item_price_base: Number(fallbackPreco),
            item_price: unitPrice,
            descontoConfirmado: calculo?.descontoConfirmado === true,
            item_marca: itemData.Marca?.[0]?.des_marca ?? exactItem.item_marca ?? product.item_marca,
            cod_marca: itemData.Marca?.[0]?.cod_marca ?? exactItem.cod_marca ?? product.cod_marca,
            imagens: itemData.imagens || [],
            item_img_princial: caminhoImagemPrincipal,
            embalagens: embalagensProcessadas.filter((emb) => emb !== null),
            familiaItemId,
            // SKU único (produtos sem grade de cor/tamanho, ex.: livros):
            // always keep the selected row id, never familyItemId.
            itemIdUnico: selectedSku,
            cdnCorUnico: product.cdn_cor ?? exactItem.cdn_cor ?? selectedGrade?.cdn_cor ?? 0,
            desCorUnico: product.des_cor ?? exactItem.des_cor ?? selectedGrade?.des_cor ?? null,
            cdnTamanhoUnico: product.cdn_tamanho ?? exactItem.cdn_tamanho ?? null,
            desTamanhoUnico: product.des_tamanho ?? exactItem.des_tamanho ?? selectedSizeKey ?? null,
            cdnEmbalagemUnico: product.cdn_embalagem ?? exactItem.cdn_embalagem ?? null,
            desEmbalagemUnico: product.des_embalag ?? exactItem.des_embalag ?? null,
            _detalheCarregado: true,
          },
        });

        if (selectedSku) {
          try {
            await new SLSEstoqueService().consultarEstoque([String(selectedSku)]);
          } catch (e) {
            console.warn('[modalAdicionarItens] Falha ao consultar estoque:', e);
          }
        }
      } catch (error) {
        console.error(`Erro ao carregar detalhe da referência ${product?.referencia}:`, error);
        if (modalEpoch === this.modalEpoch) {
          this.atualizarItemJsonTelaNovaPedido({ referencia: product.referencia, itemId: selectedSku, patch: { _detalheCarregado: true } });
        }
      } finally {
        if (modalEpoch === this.modalEpoch) {
          this.atualizarItemJsonTelaNovaPedido({ referencia: product.referencia, itemId: selectedSku, patch: { _carregandoDetalhe: false } });
        }
      }
    },
    async calcularImposto(newItem) {
      Swal.fire({
        title: 'Calculando impostos',
        html: 'Por favor, aguarde...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      this.isCalculandoImposto = true;

      try {
        const formBase = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'];
        const categoriaItem = categoriaDaLinha(newItem);
        // O primeiro WC ainda não pode alterar a capa antes de a simulação ser
        // aceita. Mesmo assim, a simulação deve enxergar o tipo proposto, não o
        // WS default que continua temporariamente no store.
        const formData = categoriaItem
          ? {
            ...formBase,
            tipoPedido: { ...(formBase?.tipoPedido || {}), tipopedidoid: categoriaItem },
            tipoPedidoCliente: {
              ...(formBase?.tipoPedidoCliente || {}),
              tipopedidoid: categoriaItem,
            },
            dataCapaPedido: {
              ...(formBase?.dataCapaPedido || {}),
              tipopedidoid: categoriaItem,
            },
          }
          : formBase;

        const estabelecimentoid = formData?.estabelecimento?.estabelecimentoid || '';
        const clienteNomeAbreviado = formData?.cliente?.clientenomeabreviado || '';
        const tabelaprecoid = formData?.tabelaPreco?.tabelapreco_id || '';
        const condicaopagamentoid = Number(formData?.condicaoPagamento?.condicaopagamentoid || 0);
        const naturezaoperacaoid = selecionarNaturezaFiscal(formData);
        // Mesmo fallback de canal usado na home/impostoSimulador: canal do
        // cliente ou da capa quando o form não tem o objeto canalVenda.
        const canal_venda_id = formData?.canalVenda?.canal_venda_id
          || formData?.cliente?.canalvendaid
          || formData?.cliente?.canal_venda_id
          || formData?.dataCapaPedido?.canalvendaid
          || '';
        const ufid = formData?.enderecoEntrega?.ufid || '';
        const cidade = formData?.enderecoEntrega?.clienteenderecocidade || '';
        const isentoIE = formData?.cliente?.clienteisentoie ? 1 : 0;

        const camposObrigatorios = [
          { valor: estabelecimentoid, nome: 'Estabelecimento' },
          { valor: clienteNomeAbreviado, nome: 'Cliente' },
          { valor: tabelaprecoid, nome: 'Tabela de Preço' },
          ...(this.$store.getters['preferencias/condicaoPagamentoAtiva'] ? [{ valor: condicaopagamentoid, nome: 'Condição de Pagamento' }] : []),
        ];

        const camposFaltando = camposObrigatorios.filter((campo) => !campo.valor);

        if (camposFaltando.length > 0) {
          Swal.close();

          camposFaltando.forEach((campo) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Campo Obrigatório',
                text: `${campo.nome} não foi selecionado. Por favor, complete os dados do pedido.`,
                icon: 'AlertCircleIcon',
                variant: 'warning',
              },
            });
          });

          throw new Error(`Campos obrigatórios não preenchidos: ${camposFaltando.map((c) => c.nome).join(', ')}`);
        }

        console.log('Estabelecimento ID:', estabelecimentoid);
        console.log('Cliente Nome Abreviado:', clienteNomeAbreviado);
        console.log('Tabela Preço ID:', tabelaprecoid);
        console.log('Condição de Pagamento ID:', condicaopagamentoid);

        // Simulação via backend (POST /api/imposto/simular): o backend resolve
        // item_id -> item_codigo_origem (ISBN/EAN) e chama a TOTVS server-side
        // com Basic Auth. Enviar o item_id interno direto para a TOTVS (ex.:
        // "74" de um livro sem grade) retornava vazio, deixando o "Salvar"
        // desabilitado; em produção o host da TOTVS nem é acessível pelo browser.
        const { data: resp } = await apiAxios.post('imposto/simular', {
          estabelecimentoid,
          clienteId: formData?.cliente?.clienteid,
          clienteNomeAbreviado,
          naturezaOperacaoId: naturezaoperacaoid,
          canalVendaId: canal_venda_id,
          itemId: newItem.item_id,
          quantidade: newItem.valor,
          precoUnitario: newItem.precoUnitario,
          ufDs: ufid,
          cidadeDs: cidade,
          contribuinteIcms: isentoIE ? 0 : 1,
          tabelaPrecoId: tabelaprecoid,
          condicaoPagamentoId: condicaopagamentoid,
        });

        // Pedido de doação (WD): usa d-preco-doacao quando disponível.
        const resultado = aplicarPrecoDoacao(resp?.data, isPedidoDoacao(formData), formData?.tipoPedidoCliente?.tipopedidoid || formData?.dataCapaPedido?.tipopedidoid);
        this.registrarCotacaoVisual(newItem.item_id, resultado);
        if (resultado && !resultado._erro && precoFinalSimulado(resultado) != null) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Sucesso',
              text: 'Imposto calculado com sucesso!',
              icon: 'CheckIcon',
              variant: 'success',
            },
          });

          return {
            // Fiscal price for this order type and exact SKU; zero blocks the line.
            precoComImposto: precoFinalSimulado(resultado),
            precoTabelaErp: precoTabelaSimulado(resultado),
            baseIcms: resultado.baseIcms || 0,
            valorIcms: resultado.valorIcms || 0,
            naturezaoperacaoidimposto: resultado.naturezaOperacao || 0,
          };
        }
        return null;
      } catch (error) {
        console.error('Erro ao calcular impostos:', error);

        if (!error.message.includes('Campos obrigatórios não preenchidos')) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro',
              text: error.message || 'Erro ao calcular impostos',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        }

        return null;
      } finally {
        Swal.close();
        this.isCalculandoImposto = false;
      }
    },
    async show(type, item) {
      await this.$bvModal.show('modal_itens');
      this.$root.$emit('modal:opened');
      this.$root.$emit('modal:sync-items');
      await this.getMarcaPedido();

      if (type === 'editar') {
        this.selected_cod_marca = await item.item.cod_marca;
        await this.getCategoriaPedido().then(() => {
          this.selected_cod_marca = item.item.cod_marca;
          this.selected_categoria = item.item.cod_categ;
        });

        await this.buscarReferencias().then(() => {
          this.selected_referencia = item.item.cod_referencia;
        });
        await this.buscaCorGradeItens(item.subItens);
      }
    },
    async resetModal() {
      this.cotacoesVisuais = {};
      this.modalEpoch += 1;
      this.calculationGeneration += 1;
      this.calculationPending = false;
      this.selectionCalculationReady = false;
      this.tipoBusca = 'codigo-referencia';
      // Carrega as options dos filtros de atributo (língua, segmento, etc.)
      this.limparFiltrosAtributo();
      this.carregarFiltrosItens();
      this.selected_cod_marca = null;
      this.selected_categoria = null;
      this.selected_referencia = null;
      this.selected_embalagem = null;
      this.busca_referencia = '';
      this.codigo_referencia_direto = '';
      this.referenciasPendentes = [];
      this.getFormData.dataItensPedido.item_price = null;
      this.clearModalItens();
      this.novosItensAdicionados = false;
      // Cache de imposto por SKU vale só para a sessão atual do modal — os
      // insumos fiscais (cliente, condição, natureza) podem mudar entre aberturas.
      this._impostoQtdCache = {};

      this.itensTabela = (this.getlistarTabelaItens || []).flatMap((item) => (item.itens || []).map((subitem) => ({
        ...subitem,
        codMarca: item.CodMarca,
        familiaComercialId: item.CodReferencia,
        marca: item.DescricaoMarca,
        descricao_referencia: item.DescricaoReferencia,
        precoUnitario: subitem.precoUnitario,
        precoComImposto: subitem.precoComImposto,
        valorTotal: subitem.valorTotal,
        pedidoItemQuantidade: subitem.pedidoItemQuantidade,
        embalagem: subitem.embalagem,
        cdn_embalagem: subitem.cdn_embalagem,
        des_cor: subitem.des_cor,
        cdn_cor: subitem.cdncor,
        tamanho: subitem.desc_tamanho,
        item_id: subitem.itemId,
        nome: subitem.item_descricao,
        valor: subitem.pedidoItemQuantidade,
      })));
      this.liberarCategoriaClienteSeVazio();
    },
    _linhaKey(item) {
      return [
        item.itemId ?? item.item_id,
        item.cdn_embalagem ?? '',
        item.des_cor ?? '',
        item.desc_tamanho ?? item.tamanho ?? '',
      ].map((part) => String(part)).join('|');
    },
    _contextoCalculo(item) {
      const formData = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] || {};
      const canalVendaId = formData?.canalVenda?.canal_venda_id
        || formData?.cliente?.canalvendaid
        || formData?.cliente?.canal_venda_id
        || formData?.dataCapaPedido?.canalvendaid
        || '';
      const tipoPedidoId = categoriaDaLinha(item)
        || formData?.tipoPedido?.tipopedidoid
        || formData?.tipoPedidoCliente?.tipopedidoid
        || formData?.dataCapaPedido?.tipopedidoid
        || '';
      return JSON.stringify([
        this._linhaKey(item),
        Number(item.precoUnitario),
        formData?.estabelecimento?.estabelecimentoid,
        formData?.cliente?.clientenomeabreviado,
        formData?.cliente?.clienteid,
        formData?.tabelaPreco?.tabelapreco_id,
        formData?.condicaoPagamento?.condicaopagamentoid,
        formData?.naturezaOperacao?.naturezaoperacaoid,
        canalVendaId,
        formData?.enderecoEntrega?.ufid || '',
        formData?.enderecoEntrega?.clienteenderecocidade || '',
        formData?.cliente?.clienteisentoie ? 1 : 0,
        tipoPedidoId,
        isPedidoDoacao(formData),
      ]);
    },
    async prepararItemParaAdicionar(item) {
      // O resultado é unitário; mudar somente a quantidade não muda a tributação.
      if (item._currentCalculation && item._currentCalculationContext === this._contextoCalculo(item)) {
        return item;
      }
      const generation = ++this.calculationGeneration;
      const modalEpoch = this.modalEpoch;
      const sourceContext = this._contextoCalculo(item);
      this.calculationPending = true;
      this.selectionCalculationReady = false;
      const itemCategorizado = await this.identificarCategoriaItemCliente(item);
      if (!itemCategorizado) {
        if (generation === this.calculationGeneration && modalEpoch === this.modalEpoch) {
          this.calculationPending = false;
        }
        return null;
      }
      if (generation !== this.calculationGeneration || modalEpoch !== this.modalEpoch) return null;
      if (sourceContext !== this._contextoCalculo(item)) {
        this.calculationPending = false;
        return null;
      }
      const context = this._contextoCalculo(itemCategorizado);
      const impostos = await this.calcularImposto({
        item_id: itemCategorizado.item_id,
        precoUnitario: itemCategorizado.precoUnitario,
        valor: itemCategorizado.valor,
        categoria_tipo_pedido: itemCategorizado.categoria_tipo_pedido,
      });
      if (generation !== this.calculationGeneration || modalEpoch !== this.modalEpoch) return null;
      if (context !== this._contextoCalculo(itemCategorizado)) {
        this.calculationPending = false;
        return null;
      }
      const precoEfetivo = Number(impostos?.precoComImposto);
      if (!impostos || !Number.isFinite(precoEfetivo) || precoEfetivo <= 0) {
        this.calculationPending = false;
        return null;
      }
      if (!this.confirmarCategoriaItemCliente(itemCategorizado)) {
        this.calculationPending = false;
        return null;
      }
      return {
        ...itemCategorizado,
        _currentCalculation: { ...impostos, precoComImposto: precoEfetivo },
        _currentCalculationContext: context,
      };
    },
    async updatedGradeItens(value) {
      const selecionados = Array.isArray(value) ? value.filter(Boolean) : [];
      const generation = ++this.calculationGeneration;
      const modalEpoch = this.modalEpoch;
      const contexts = selecionados.map((item) => this._contextoCalculo(item));
      this.calculationPending = selecionados.length > 0;
      this.selectionCalculationReady = false;
      if (selecionados.length === 0) return;

      const calculados = [];
      for (let index = 0; index < selecionados.length; index += 1) {
        const item = selecionados[index];
        const qtd = parseInt(item.valor, 10);
        let impostos = item._currentCalculationContext === contexts[index]
          ? item._currentCalculation
          : null;
        if (!impostos) {
          // eslint-disable-next-line no-await-in-loop
          impostos = await this.calcularImposto({
            item_id: item.item_id,
            precoUnitario: item.precoUnitario,
            valor: qtd,
          });
        }
        if (generation !== this.calculationGeneration
          || modalEpoch !== this.modalEpoch
          || contexts[index] !== this._contextoCalculo(item)) return;
        const precoEfetivo = Number(impostos?.precoComImposto);
        if (!impostos || !Number.isFinite(precoEfetivo) || precoEfetivo <= 0 || !Number.isFinite(qtd) || qtd <= 0) {
          this.calculationPending = false;
          return;
        }
        calculados.push({ item, qtd, impostos: { ...impostos, precoComImposto: precoEfetivo } });
      }

      calculados.forEach(({ item, qtd, impostos }) => {
        const {
          precoComImposto, baseIcms, valorIcms, naturezaoperacaoidimposto,
        } = impostos;
        const newItem = {
          uniqueId: item.uniqueId,
          codMarca: this.selected_cod_marca,
          familiaComercialId: item.referencia,
          cdncor: item.cdn_cor,
          des_cor: item.des_cor,
          cdn_tamanho: item.tamanho,
          itemId: item.item_id,
          item_id: item.item_id,
          item_descricao: `${item.nome} ${item.tamanho} ${item.des_cor}`,
          itemDescricao: `${item.nome} ${item.tamanho} ${item.des_cor}`,
          descricao_referencia: item.nome,
          pedidoItemQuantidade: qtd,
          marca: item.marca,
          embalagem: item.embalagem,
          cdn_embalagem: item.cdn_embalagem,
          precoUnitario: item.precoUnitario,
          valorTotal: precoComImposto * qtd,
          pedidoItemQuantidadeSaldo: 0,
          pedidoItemQuantidadeFaturada: 0,
          pedidoitemseq: 0,
          desc_tamanho: item.tamanho,
        precoComImposto,
        precoTabelaErp: impostos.precoTabelaErp,
          baseIcms,
          valorIcms,
          itemMultiplo: item.itemMultiplo || 1,
          naturezaoperacaoidimposto,
          categoria_tipo_pedido: item.categoria_tipo_pedido,
          _requiresCurrentCalculation: true,
          _calculationReady: true,
          _calculationContext: this._contextoCalculo(item),
        };
        const idxExistente = this.itensTabela.findIndex(
          (linha) => this._linhaKey(linha) === this._linhaKey(newItem),
        );
        if (idxExistente === -1) this.itensTabela.push(newItem);
        else this.$set(this.itensTabela, idxExistente, { ...this.itensTabela[idxExistente], ...newItem });
      });
      this.calculationPending = false;
      this.selectionCalculationReady = true;
      this.novosItensAdicionados = true;
    },
    /**
     * Remove somente a linha emitida pela TelaNovaPedido. A quantidade não faz
     * parte da identidade: vários SKUs/grades podem legitimamente ter o mesmo
     * valor (por exemplo, duas linhas com quantidade 1).
     */
    handleRemoveItem(item) {
      this.calculationGeneration += 1;
      this.calculationPending = false;
      let idx = item?.uniqueId
        ? this.itensTabela.findIndex((line) => line.uniqueId === item.uniqueId)
        : -1;

      if (idx === -1) {
        const normalize = (value) => String(value ?? '').trim();
        idx = this.itensTabela.findIndex((line) => (
          normalize(line.itemId ?? line.item_id) === normalize(item?.item_id ?? item?.itemId)
          && normalize(line.familiaComercialId ?? line.referencia) === normalize(item?.referencia)
          && normalize(line.cdncor ?? line.cdn_cor) === normalize(item?.cdn_cor ?? item?.cdncor)
          && normalize(line.desc_tamanho ?? line.cdn_tamanho ?? line.tamanho)
            === normalize(item?.tamanho ?? item?.desc_tamanho ?? item?.cdn_tamanho)
          && normalize(line.cdn_embalagem) === normalize(item?.cdn_embalagem)
        ));
      }

      if (idx !== -1) {
        this.itensTabela.splice(idx, 1);
      }
      this.novosItensAdicionados = this.itensTabela.length > 0;
      this.selectionCalculationReady = this.itensTabela
        .some((linha) => linha._requiresCurrentCalculation && linha._calculationReady);
      this.liberarCategoriaClienteSeVazio();
    },
    async handleOk(bvModalEvt) {
      if (bvModalEvt?.preventDefault) bvModalEvt.preventDefault();
      if (!this.podeAdicionarItens) return;
      const generation = this.calculationGeneration;
      const modalEpoch = this.modalEpoch;
      await this.addItens();
      if (generation !== this.calculationGeneration || modalEpoch !== this.modalEpoch) return;
      this.handleSubmit();
      this.clearModalItens();
    },
    async addItens() {
      console.log('addItens', this.itensTabela);

      const itensAgrupadosPorSku = this.itensTabela.reduce((acc, item) => {
        const itemId = item.itemId || item.item_id;
        if (!itemId) return acc;
        const skuKey = String(itemId);
        const familiaComercialId = item.familiaComercialId ?? item.referencia ?? null;
        if (!acc[skuKey]) {
          acc[skuKey] = {
            CodMarca: item.codMarca,
            DescricaoMarca: item.marca,
            CodReferencia: familiaComercialId,
            DescricaoReferencia: item.descricao_referencia
              || item.item_descricao || item.itemDescricao,
            // Keep the real family for downstream order metadata while using
            // skuKey for row identity, so sibling SKUs never collapse.
            referencia: familiaComercialId,
            skuKey,
            item_id: itemId,
            item_descricao: item.item_descricao || item.itemDescricao || item.nome,
            Qtde: 0,
            PrecoUnitario: item.precoUnitario,
            ValorTotal: 0,
            PrecoComImposto: item.precoComImposto || 0,
            BaseIcms: 0,
            ValorIcms: 0,
            sequencia: Object.keys(acc).length + 1,
            // naturezaoperacaoidimposto: item.naturezaoperacaoidimposto,
            itens: [],
            editar: {
              cod_marca: item.codMarca,
              cod_categ: this.selected_categoria,
              cod_referencia: familiaComercialId,
              precoId: this.getFormData.dataCapaPedido.tabelaprecoid,
            },
          };
        }
        acc[skuKey].Qtde += item.pedidoItemQuantidade;
        acc[skuKey].ValorTotal += item.pedidoItemQuantidade * item.precoUnitario;
        acc[skuKey].BaseIcms += (item.baseIcms || 0) * item.pedidoItemQuantidade;
        acc[skuKey].ValorIcms += (item.valorIcms || 0) * item.pedidoItemQuantidade;

        acc[skuKey].itens.push({
          ...item,
          precoComImposto: item.precoComImposto || 0,
          baseIcms: item.baseIcms || 0,
          valorIcms: item.valorIcms || 0,
          valorTotalComImposto: (item.precoComImposto || item.precoUnitario) * item.pedidoItemQuantidade,
          naturezaoperacaoidimposto: item.naturezaoperacaoidimposto,
        });

        return acc;
      }, {});

      console.log('itensAgrupadosPorSku com impostos', itensAgrupadosPorSku);

      for (const skuKey in itensAgrupadosPorSku) {
        const item = itensAgrupadosPorSku[skuKey];
        await this.setListTabelaItens(item);
      }
    },
  },
};
</script>

<style scoped>
.container-images-prod {
  width: 500px;
}

.loading-indicator {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  justify-content: center;
}

/* Filtros de atributo (Língua, Segmento, Nível educacional…):
   label fica em uma linha só e o select alinha à base dos demais. */
.filtro-atributo-group ::v-deep label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.modal-add-product {
  --map-primary: var(--sf-accent, #2563eb);
}

.client-info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--sf-accent, #2563eb);
  color: white;
  padding: 0.75rem 1rem;
  margin-bottom: 1.5rem;
  border-radius: 4px;

  .client-info {
    display: flex;
    align-items: center;
    gap: 0.75rem;

    feather-icon {
      opacity: 0.9;
    }
  }

  .order-info {
    display: flex;
    gap: 1.5rem;
  }

  .info-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .info-content {
    display: flex;
    flex-direction: column;
    line-height: 1.1;

    .label {
      font-size: 0.65rem;
      opacity: 0.8;
      text-transform: uppercase;
      font-weight: 500;
      letter-spacing: 0.5px;
    }

    .value {
      font-size: 0.85rem;
      font-weight: 600;
      color: white;
    }
  }
}

.modal-actions-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1.5rem;
  padding-top: 1rem;
  /* Footer fixo no rodapé do modal: o usuário salva sem rolar até o fim.
     Fundo opaco (compatível com claro/escuro) e z-index acima do conteúdo. */
  position: sticky;
  bottom: 0;
  z-index: 5;
  padding-bottom: 1rem;
  /* Compensa o padding lateral do corpo do modal para o fundo cobrir a largura. */
  margin-left: -1rem;
  margin-right: -1rem;
  padding-left: 1rem;
  padding-right: 1rem;
  background: var(--sf-surface, #ffffff);
  border-top: 1px solid var(--sf-border-color, #e2e8f0);

  .items-summary {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0.75rem;
    background: var(--sf-surface-secondary, #f8fafc);
    border-radius: 6px;
    min-width: 0;

    .summary-count {
      font-weight: 600;
      color: var(--sf-accent, #2563eb);
      font-size: 0.9rem;
      white-space: nowrap;
    }

    .summary-nomes {
      color: var(--sf-text-secondary, #64748b);
      font-size: 0.8rem;
      max-width: 320px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .summary-separator {
      color: var(--sf-border-color, #cbd5e1);
    }

    .summary-total {
      font-weight: 600;
      color: var(--sf-text-primary, #334155);
      white-space: nowrap;
    }
  }

  .actions-buttons {
    display: flex;
    gap: 0.75rem;
  }
}

:global(body.dark-layout) {
  .client-info-bar {
    background: var(--sf-accent-dark, #5e50ee);
  }

  /* Fundo opaco escuro para o footer sticky não deixar o conteúdo aparecer atrás. */
  .modal-actions-footer {
    background: var(--sf-surface-dark, #283046);
  }
}
</style>
